<template>
<div class="chapter">
<div class="inner_page">
<div class="box">
<p class="epi"><a id="page_v">My thanks to Anne Ramsey, Director of the Dalcroze School at the Lucy Moses School in New York City, who adapted “The Birdies Fly Away” song from Engelbert Humperdinck and graciously gave me permission to use it. My thanks also to Haeeun Shin, talented Eurhythmics teacher at the Concord Conservatory of Music in Concord, Massachusetts, who taught the song to my grandchildren, Sofia and Nicholas.</a></p><a id="page_v">
<p class="epic">—Patricia MacLachlan</p>
</a></div><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?27af4b22